import {
  type GetWorkplaceStarredProfessionalsResponse,
  GetWorkplaceStarredProfessionalsResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment/config";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

import { WORKPLACE_STARRED_PROFESSIONALS_CACHE_SETTINGS } from "./constants";

export function getWorkplaceStarredProfessionalsUrl(workplaceId: string) {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/starred-professionals`;
}

export function useGetWorkplaceStarredProfessionals(
  params: { workplaceId: string },
  options: UseGetQueryOptions<GetWorkplaceStarredProfessionalsResponse> = {}
) {
  const { workplaceId } = params;
  return useGetQuery({
    url: getWorkplaceStarredProfessionalsUrl(workplaceId),
    responseSchema: GetWorkplaceStarredProfessionalsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKPLACE_STARRED_PROFESSIONALS_FAILURE,
    },
    ...WORKPLACE_STARRED_PROFESSIONALS_CACHE_SETTINGS,
    ...options,
  });
}
